import { ImageProps } from './types'

const Image = ({ src, alt, className }: ImageProps) => {
    if (!src) {
        return null
    }

    return <img className={className} src={src} alt={alt} />
}

export default Image
